import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "flex-grow" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = { class: "ml-5 text-sm text-gray-500" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-between"
}

import { Faction } from '@/typings/faction';
import { Scorecard } from '@/typings/scorecard';
import { computed, PropType, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import User from '../User/User.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  faction: {
    type: Object as PropType<Faction>,
    required: true,
  },
  scorecard: {
    type: Object as PropType<Scorecard>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { scorecard, faction } = toRefs(props);

const cardImage = computed(
  () => process.env.VUE_APP_IMAGE_PATH + scorecard.value.CoverImage
);

const year = computed(() => new Date(scorecard.value.LocksAt).getFullYear());

const router = useRouter();

function open() {
  router.push({
    name: 'FactionScorecard',
    params: {
      factionId: faction.value.Uuid,
      slug: scorecard.value.Slug,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center w-full px-3 py-2 cursor-pointer sm:w-1/2 hover:bg-gray-100",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (open()))
  }, [
    _createElementVNode("img", {
      class: "flex-shrink w-32 mr-5 min-w-32",
      src: _unref(cardImage)
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(scorecard).Title), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(year)), 1)
      ]),
      (_unref(scorecard).Rankings && _unref(scorecard).Rankings[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(User, {
              user: _unref(scorecard).Rankings[0].User,
              "hide-tags": ""
            }, null, 8, ["user"]),
            _createElementVNode("span", null, _toDisplayString(_unref(scorecard).Rankings[0].Score), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})